import {Button, Form, Input, message} from "antd";
import TextArea from "antd/es/input/TextArea";
import captchApi from "../../../../api/captch";
import {useState} from "react";
import ModalCaptcha from "../../../../compenents/modal-captcha";
import businessApi from "../../../../api/business";

const width = 300
const height = 150

const Demand = () => {

    const [form] = Form.useForm();
    const [imgId, setImgId] = useState("")
    const [img, setImg] = useState("")
    const [formData, setFormData] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    // 联系电话验证
    function validatePhone(rule, value) {
        if (value === "" || value === undefined) {
            return Promise.resolve();
        }
        // 定义一个正则表达式，用于匹配纯数字，并且位数在4到11之间
        const regex = /^\d{4,11}$/;
        // 测试输入是否匹配正则表达式
        if (regex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject('您输入的联系电话不正确！');
    }

    // 邮箱验证
    function validateEmail(_, value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (value && !emailRegex.test(value)) {
            return Promise.reject('您输入的电子邮箱不正确！');
        }
        return Promise.resolve();
    }


    function handleClick() {
        form.validateFields().then(value => {
            setFormData(value)
            setIsModalOpen(true)
            getImage()
        }).catch(e => console.log(e));
    }

    const handleCaptchaCancel = () => setIsModalOpen(false)

    function handleCaptchaOk(value) {
        // 提交咨询
        const data = {
            captcha: {
                key: imgId,
                code: value.code,
            },
            ...formData
        }
        businessApi.submit(data).then(() => messageApi.success('提交成功')).catch(e => messageApi.error(e.msg))
        setIsModalOpen(false)
    }

    function getImage() {
        captchApi.get({
            width: width,
            height: height
        }).then(res => {
            setImgId(res.data.key)
            setImg(res.data.image)
        }).catch(() => messageApi.error("提交失败：初始化人机识别异常！"))
    }

    return (
        <div>
            {contextHolder}
            <h2>告诉我们您的需求</h2>

            <Form autoComplete="off" validateTrigger="onSubmit" layout="vertical" form={form}>
                <Form.Item name='name' label="您的姓名" rules={[
                    {
                        required: true,
                        message: '请输入您的姓名',
                    },
                    {
                        max: 20,
                        message: '您输入的姓名不正确'
                    }
                ]}>
                    <Input placeholder="您的姓名"/>
                </Form.Item>

                <Form.Item name='phone' label="联系电话" rules={[
                    {
                        required: true,
                        message: '请输入您的联系电话',
                    },
                    {
                        max: 20,
                        message: '您输入的联系电话不正确'
                    },
                    {
                        validator: validatePhone
                    }
                ]}>
                    <Input placeholder="联系电话"/>
                </Form.Item>

                <Form.Item name='email' label="电子邮箱" rules={[
                    {
                        required: true,
                        message: '请输入您的电子邮箱',
                    },
                    {
                        max: 100,
                        message: '您输入的电子邮箱不正确'
                    },
                    {
                        validator: validateEmail
                    }
                ]}>
                    <Input placeholder="电子邮箱"/>
                </Form.Item>

                <Form.Item name='demand' label="详细需求" rules={[
                    {
                        required: true,
                        message: '请输入您的详细需求',
                    },
                    {
                        max: 500,
                        message: '您输入的需求描述太长了'
                    }
                ]}>
                    <TextArea rows={6} placeholder="详细需求" maxLength={500}/>
                </Form.Item>
            </Form>

            <Button type="primary" shape="round" onClick={handleClick}>
                提交需求
            </Button>

            <ModalCaptcha width={width} height={height} img={img} open={isModalOpen}
                          onOk={handleCaptchaOk} onCancel={handleCaptchaCancel}
                          onCaptcha={getImage}/>
        </div>
    )
}

export default Demand